import React, { useState, useEffect } from 'react';
import './CategoryGrid.css';
import { useLanguage } from '../../../context/LanguageContext';

const CategoryGrid = ({ categories, products, id }) => {
  const { t, lang } = useLanguage();
  const [translatedData, setTranslatedData] = useState({});

  // OTOMATİK ÇEVİRİ MOTORU
  const translateText = async (text, targetLang) => {
    if (!text || targetLang === 'TR') return text;
    const cacheKey = `${text.trim()}_${targetLang}`;
    if (translatedData[cacheKey]) return translatedData[cacheKey];

    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=${targetLang.toLowerCase()}&dt=t&q=${encodeURI(text)}`
      );
      const data = await response.json();
      const result = data[0][0][0];
      setTranslatedData(prev => ({ ...prev, [cacheKey]: result }));
      return result;
    } catch (error) {
      return text;
    }
  };

  useEffect(() => {
    if (lang !== 'TR' && categories.length > 0) {
      categories.forEach(cat => {
        translateText(cat.title, lang);
        translateText(cat.description, lang);
      });
    }
  }, [categories, lang]);

  const getDisplayValue = (originalText) => {
    const cacheKey = `${originalText?.trim()}_${lang}`;
    return translatedData[cacheKey] || originalText;
  };

  // KANKA ASIL SİHİRLİ SCROLL BURADA
  const scrollToCategory = (catId) => {
    // Alttaki listede her kategorinin başına id olarak "section-kategoriID" verdik
    const element = document.getElementById(`section-${catId}`);
    if (element) {
      // Navbar yüksekliği kadar (yaklaşık 80px) yukarıda durması için offset ekliyoruz
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const calculateProductCount = (catId) => {
    if (!products) return 0;
    return products.filter(product => product.categoryId === catId).length;
  };

  return (
    <section className="category-section" id={id}>
      <div className="category-header">
        <span className="section-badge">{t('catalog.categories.badge')}</span>
        <h2 className="section-title">{t('catalog.categories.title')}</h2>
        <p className="section-subtitle">{t('catalog.categories.subtitle')}</p>
      </div>

      <div className="category-grid">
        {categories && categories.length > 0 ? (
          categories.map((category) => {
            const productCount = calculateProductCount(category.id);

            return (
              <div 
                className="category-card" 
                key={category.id} 
                onClick={() => scrollToCategory(category.id)} // Kanka kartın tamamı artık scroll yapıyor
              >
                <div className="card-info-badge">
                  <span className="badge-count">{productCount}</span>
                  <span className="badge-text">{t('catalog.categories.unit')}</span>
                </div>

                <div className="card-main-content">
                  <h3 className="card-title">
                    {getDisplayValue(category.title)}
                  </h3>
                  <p className="card-description">
                    {getDisplayValue(category.description)}
                  </p>
                </div>

                <button className="card-button">
                  {t('catalog.categories.btn')} <span>→</span>
                </button>
              </div>
            );
          })
        ) : (
          <p className="no-data">Loading...</p>
        )}
      </div>
    </section>
  );
};

export default CategoryGrid;